import { TextField, styled } from "@mui/material";

//mui styles
export const muistyles = {
    basicheaderlinks: {
        fontWeight: 700,
        fontSize: 12,
        borderRadius: 10,
        color: "#121212",
        lineHeight: '20px',
        textTransform: "none",
        marginRight: '10'
    },
    accountmenulink: {
        fontWeight: "700",
        fontSize: 13
    },
    useappbutton: {
        borderRadius: 10,
        marginTop: '20px',
        marginBottom: '15px'
    },
    selectinput: {
        maxHeight: 20,
        marginRight: 5,
        width: 300,
        marginBottom: 5,
        fontSize: 14
    },
    textinputstyle: {
        maxHeight: 20,
        marginBottom: 5,
        width: "100%"
    },
    textsearchinputstyles: {
        maxHeight: 20,
        marginRight: 5,
        width: 200,
        marginBottom: 5,
        fontSize: 14
    },
    searchbar: {
        marginTop: 3,
        borderRadius: 20,
        width: "100%"
    }

}

// mui text search bar input
export const StyledTextField = styled(TextField)(({ theme }) => ({
    width: '100%',
    marginTop: 5,
    "& .MuiOutlinedInput-root": {
        "& fieldset": {
            border: `1px solid ${theme.palette.divider}`,
        },
        "&:hover fieldset": {
            border: `1px solid ${theme.palette.divider}`,
        },
        "&.Mui-focused fieldset": {
            borderBottom: `2px solid ${theme.palette.primary.main}`,
        },
    },
}));


// mui text search bar input
export const StyledsearchTextField = styled(TextField)(({ theme }) => ({
    width: '100%',
    marginTop: 5,
    "& .MuiOutlinedInput-root": {
        "& fieldset": {
            border: `1px solid silver`,
        },
        "&:hover fieldset": {
            border: `1px solid silver`,
        },
        "&.Mui-focused fieldset": {
            border: `2px solid silver`,
        },
    },
}));

